import {
  REQUEST_GET_PROVISIONAL_CLAIM_DETAILS,
  REQUEST_SET_PROVISIONAL_CLAIM_DETAILS,
  REQUEST_CREATE_MISSION,
  RESET_PROVISIONAL_CLAIM_DETAILS_STORE,
  SET_PROVISIONAL_CLAIM_REFERENCE,
  REQUEST_UPDATE_CLAIM_NUMBER,
  SET_UPDATE_CLAIM_NUMBER_RESULT,
  REQUEST_VALIDATE_PROVISIONAL_LIAISON,
  REQUEST_REJECT_PROVISIONAL_LIAISON,
} from 'containers/ProvisionalClaimRecap/constants';
import { provisionalMissionType } from 'typings/globalTypes';

export const requestGetProvisionalClaimDetails = (
  provisionalClaimId: number,
  isIntervenant: boolean,
) => ({
  type: REQUEST_GET_PROVISIONAL_CLAIM_DETAILS,
  provisionalClaimId,
  isIntervenant,
});

export const setProvisionalClaimDetails = (payload: any) => {
  return {
    type: REQUEST_SET_PROVISIONAL_CLAIM_DETAILS,
    payload,
  };
};
export const requestCreateMission = (
  payload: provisionalMissionType,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_CREATE_MISSION,
    payload,
    successCallBack,
  };
};

export const resetProvisionalClaimDetailsStore = () => {
  return {
    type: RESET_PROVISIONAL_CLAIM_DETAILS_STORE,
  };
};

export const setProvisionalClaimReference = (reference: string) => {
  return {
    type: SET_PROVISIONAL_CLAIM_REFERENCE,
    reference,
  };
};

export const requestUpdateClaimNumber = (
  provisionalClaimId: number,
  claimNumber: string,
  failedCallBack: Function,
) => {
  return {
    type: REQUEST_UPDATE_CLAIM_NUMBER,
    provisionalClaimId,
    claimNumber,
    failedCallBack,
  };
};

export const setUpdateClaimNumberResult = (result: {
  isClaimNumberExist: boolean;
  isProvisionalClaimUpdated: boolean;
}) => {
  return {
    type: SET_UPDATE_CLAIM_NUMBER_RESULT,
    result,
  };
};

export const requestValidateProvisionalLiaison = (
  provisionalClaimId: number,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_VALIDATE_PROVISIONAL_LIAISON,
    provisionalClaimId,
    successCallBack,
  };
};

export const requestRejectProvisionalLiaison = (
  provisionalClaimId: number,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_REJECT_PROVISIONAL_LIAISON,
    provisionalClaimId,
    successCallBack,
  };
};
